import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { DatePickerSelection } from "@net3-multiplatform-client/libs";
import { differenceInDays, subDays } from "date-fns";
import { ENVIRONMENT, Environment } from "libs/core/auth/auth.tokens";
import { PaginatedResult } from "libs/domain";
import { SectorHistoryTableRow } from "libs/features/sectors/models/sector.interfaces";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class HistoryService {

  private http = inject(HttpClient);
  private options: Environment = inject(ENVIRONMENT);
  private baseUrl;
  

  constructor() {
    this.baseUrl = `${this.options.baseUrl.data}`;
  }
  
  getSectorHistory(
      tenantId: string,
      sector: number,
      page: number,
      size: number,
      from: string,
      to: string,
      agroupation: number 
    ) : Observable<PaginatedResult<SectorHistoryTableRow>> {
    let params: HttpParams = new HttpParams();
    params = params.append('page', page);
    params = params.append('size', size);
    params = params.append('from', from);
    params = params.append('to', to);
    params = params.append('agroupation', agroupation);
    if(sector != 0) params = params.append('sector', sector);
    return this.http.get<PaginatedResult<SectorHistoryTableRow>>(`${this.baseUrl}/communities/${tenantId}/sector-acumulated-history`, {params})
  }

}